import { css } from 'aphrodite';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { useEventLogging } from '../../../../models/Logging';
import {
	selectBoundMeetingPrepTemplate,
	useMeetingPrepTemplatesQuery,
} from '../../../../queries/MeetingPrep/useMeetingPrepTemplates';
import { Button } from '../../../components-v2/Button';
import { ROUTES } from '../../../constants/routes';
import { XIconNew } from '../../svgs/icons/XIcon';
import { DashboardCard, DashboardCardHeaderLabel } from '../DashboardCard';
import { useFeatureCard } from '../DashboardCustomContentCard/useFeatureCard';
import { styleSheet } from './styles';
import { CalendarIcon } from '@WebComponents/svgs/icons/CalendarIcon';

const TELEMETRY_CATEGORY = 'DashboardMeetingPrepPromoCard';

export const DashboardMeetingPrepPromoCard: FC = () => {
	const userSession = useUserSession();
	const history = useHistory();
	const { logEvent } = useEventLogging(TELEMETRY_CATEGORY);
	const { showCard, onClose } = useFeatureCard({ cardName: 'meeting-prep-dashboard-card' });

	const enabled = !!userSession.account?.features?.meetingPrep?.enabled;
	const templatesQuery = useMeetingPrepTemplatesQuery({ enabled: enabled && showCard });

	if (!enabled || !showCard || templatesQuery.isPending || templatesQuery.isError) {
		return null;
	}

	if (selectBoundMeetingPrepTemplate(templatesQuery.data ?? [])) {
		return null;
	}

	return (
		<DashboardCard styleDeclaration={styleSheet.card}>
			<div className={css(styleSheet.cardHeader)}>
				<DashboardCardHeaderLabel styleDeclaration={styleSheet.headerContent}>
					<span className={css(styleSheet.icon)}>
						<CalendarIcon />
					</span>
					<span className={css(styleSheet.title)}>Meet your Meeting Prep Assistant</span>
				</DashboardCardHeaderLabel>
				<Button
					variant='ghost'
					size='icon'
					onClick={() => {
						logEvent('PromoDismissed');
						onClose();
					}}
				>
					<XIconNew />
				</Button>
			</div>
			<div className={css(styleSheet.body)}>
				<p className={css(styleSheet.description)}>
					A brief for every meeting on your calendar — who you're meeting, what you last talked about, and what to
					raise, waiting for you before the day starts.
				</p>
				<div className={css(styleSheet.actions)}>
					<Button
						size='sm'
						onClick={() => {
							logEvent('SetUpClicked');
							history.push(ROUTES.meetingPrep.settings);
						}}
					>
						Set up Meeting Prep
					</Button>
				</div>
			</div>
		</DashboardCard>
	);
};
